var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames, entityTypeNameFor } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { EntityList } from './entity-list';
import { EntityValue } from './entity-value';
import { useLang } from '../hooks/use-lang';
var cls = classNames('entity-aside-menu-layout');
export var entityAsideMenuKey = function (entity) {
  if (!entity) {
    return '';
  }
  return "".concat(entityTypeNameFor(entity), ":").concat(entity.name);
};
export var EntityAsideMenuDefaultProps = {
  showAllItem: false
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "])), theme.UNIT(3))
});
var PaddingStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding-left: ", ";\n    padding-right: ", ";\n  "], ["\n    padding-left: ", ";\n    padding-right: ", ";\n  "])), theme.UNIT(4), theme.UNIT(4))
});
var EntityListStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), PaddingStyles)
});
var ItemsStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    flex-direction: column;\n  "])))
});
var ItemStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", ";\n    padding-top: ", ";\n    padding-bottom: ", ";\n    cursor: pointer;\n    transition: background-color 0.3s;\n\n    ", "\n\n    &:hover {\n      background: ", ";\n      filter: brightness(1.1);\n\n      ", "\n      \n    }\n  "], ["\n    ", ";\n    padding-top: ", ";\n    padding-bottom: ", ";\n    cursor: pointer;\n    transition: background-color 0.3s;\n\n    ", "\n\n    &:hover {\n      background: ", ";\n      filter: brightness(1.1);\n\n      ", "\n      \n    }\n  "])), PaddingStyles, theme.UNIT(3), theme.UNIT(3, 2), function (_a) {
    var isActive = _a.isActive;
    return isActive && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      background: ", ";\n    "], ["\n      background: ", ";\n    "])), theme.COLOR('subtle-chrome'));
  }, theme.COLOR('canvas'), function (_a) {
    var isActive = _a.isActive;
    return isActive && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n        cursor: default;\n        filter: brightness(1);\n        background: ", ";\n      "], ["\n        cursor: default;\n        filter: brightness(1);\n        background: ", ";\n      "])), theme.COLOR('subtle-chrome'));
  })
});
var AllItemsStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", ";\n    font-size: 0.8em;\n  "], ["\n    ", ";\n    font-size: 0.8em;\n  "])), ItemStyles)
});
// -------- Components -------->
var My = {
  NAME: 'EntityAsideMenu',
  Container: styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  EntityList: styled(EntityList)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), EntityListStyles),
  Items: styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ItemsStyles),
  Item: styled(EntityValue)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles)
};
export var EntityAsideMenu = function (props) {
  var _a = useComponentProps(My.NAME, EntityAsideMenuDefaultProps, props),
    className = _a.className,
    children = _a.children,
    items = _a.items,
    activeItemKey = _a.activeItemKey,
    showAllItem = _a.showAllItem,
    renderItem = _a.renderItem,
    renderAllItem = _a.renderAllItem;
  var t = useLang();
  var handleItemClick = function (entity) {
    return function (event) {
      var _a;
      event.preventDefault();
      event.stopPropagation();
      (_a = props.onItemClick) === null || _a === void 0 ? void 0 : _a.call(props, entity);
    };
  };
  var handleAllItemClick = function (event) {
    var _a;
    event.preventDefault();
    event.stopPropagation();
    (_a = props.onItemClick) === null || _a === void 0 ? void 0 : _a.call(props, {});
  };
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Items, null, renderAllItem && renderAllItem(activeItemKey === 'all-items', handleAllItemClick), items.map(function (item) {
    var isActive = activeItemKey == item.id;
    var onClickHandler = handleItemClick(item);
    if (renderItem) {
      var customElement = renderItem(item, isActive, onClickHandler);
      if (customElement && React.isValidElement(customElement)) {
        return React.cloneElement(customElement, {
          key: item.id
        });
      }
      return null;
    }
    return React.createElement(My.Item, {
      isActive: isActive,
      key: item.id,
      entity: item,
      onClick: onClickHandler
    });
  })), children);
};
EntityAsideMenu.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;